const { useClientRequest } = require('./useClientRequest.hook')

export const useService = () => {
    const { getAjaxContent } = useClientRequest()

    const getContactId = async (url) => {
        const { result: { CONTACT } = {} } = await getAjaxContent(url)
        return CONTACT
    }

    const getContact = async (url, body) => {
        const json = JSON.stringify({ ...body, 'app-token': '14bcb98a-58ad-44dd-bc7d-408460dee902' })
        const base64 = btoa(json)
        body = {
            request: base64,
        }
        let { result } = await getAjaxContent(url, body)
        result = JSON.parse(atob(result))
        return result.items
    }

    const getCompanyByCookie = async ({ cookies, scheme }) => {
        return getContact(`/slam.form.autocomplete.cookies`, {
            cookies,
            scheme,
        })
    }

    const getContactIdByPhone = async ({ phone, scheme }) => {
        return getContact(`/slam.form.autocomplete.phone`, {
            phone,
            scheme,
        })
        //   return getContactId(`/crm.duplicate.findbycomm?entity_type=CONTACT&type=PHONE&values[]=${phone}`)
    }

    const getContactIdByMail = async ({ email, scheme }) => {
        return getContact(`/slam.form.autocomplete.email`, {
            email,
            scheme,
        })
        //   return getContactId(`/crm.duplicate.findbycomm?entity_type=CONTACT&type=EMAIL&values[]=${email}`)
    }

    const getCompanyByContactId = async ({ contact, scheme }) => {
        return getContact(`/slam.form.autocomplete.company`, {
            contact,
            scheme,
        })
    }

    const getCompanyRequisites = async (id) => {
        const { result } = await getAjaxContent(`/crm.requisite.list?filter[ENTITY_TYPE_ID]=4&filter[ENTITY_ID]=${id}`)
        return result
    }

    const sendAnalytics = async (ID) => {
        const payload = {
            ENTITIES: [{ TYPE: 'DEAL', ID }],
            TRACE: window.b24Tracker.guest.getTrace(),
        }

        getAjaxContent(`/crm.tracking.trace.add`, payload)
    }

    //   const get

    return {
        getContactIdByPhone,
        getContactIdByMail,
        sendAnalytics,
        getCompanyByCookie,
        getCompanyRequisites,
        getCompanyByContactId,
    }
}
